import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const assetsConfigurationRoute: InvariantJiraRoute = {
	name: 'assets-configure',
	path: '/jira/assets/configure/global',
};
